import axios from 'axios';
import ENDPOINT from './../../endpoints';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import {add0StringToNumberLessThan10} from '@/util/dateTimeUtils';
import {
  REQUEST_COVERAGE_FILTER_DATA_MODEL,
  REQUEST_COVERAGE_USAGE_MODEL,
  REQUEST_COVERAGE_TOTAL_SUMMARY_MODEL,
  REQUEST_COVERAGE_TRANSITION_MODEL
} from '@/constants/reserved/coverageConstants';
import {isFailResponse, addLoginUserInfoToPayload} from '@/util/apiUtils';
import store from '@/store';

export function fetchFilterData(payload) {
  let fetchFilterDataPayload = {
    ...REQUEST_COVERAGE_FILTER_DATA_MODEL
  };

  fetchFilterDataPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.COVERAGE.FILTER_DATA, fetchFilterDataPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchCoverageList(payload) {
  let fetchUsageListPayload = {
    ...REQUEST_COVERAGE_USAGE_MODEL
  };

  fetchUsageListPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.COVERAGE.USAGE_LIST, fetchUsageListPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTotalSummary(payload) {
  let fetchTotalSummaryPayload = {
    ...REQUEST_COVERAGE_TOTAL_SUMMARY_MODEL
  };

  fetchTotalSummaryPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.COVERAGE.TOTAL_SUMMARY, fetchTotalSummaryPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || {});
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function fetchTransition(payload) {
  let fetchTransitionPayload = {
    ...REQUEST_COVERAGE_TRANSITION_MODEL
  };

  fetchTransitionPayload = addLoginUserInfoToPayload(payload, store);

  return new Promise((resolve, reject) => {
    return axios.post(ENDPOINT.RESERVED.COVERAGE.TRANSITION, fetchTransitionPayload)
      .then((response) => {
        if (isFailResponse(response)) {
          reject(response.data.error);
        } else {
          resolve(_get(response, 'data.Data') || []);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}





// WEBPACK FOOTER //
// ./src/api/reserved/coverage/index.js